import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'cookie_consent_v1';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setShow(true);
  }, []);

  const accept = (level) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ level, timestamp: Date.now() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#09090B] text-white border-t-2 border-[#09090B]"
      data-testid="cookie-banner">
      <div className="container-swiss py-4 flex flex-col md:flex-row items-start md:items-center gap-4">
        <Cookie className="w-5 h-5 text-white flex-shrink-0" />
        <div className="flex-1 text-xs md:text-sm">
          <p>
            We use essential cookies (session token) to keep you signed in. No ads, no tracking.
            See our{' '}
            <Link to="/privacy" className="underline text-white">Privacy Policy</Link>.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => accept('essential')}
            className="bg-white text-black px-4 py-1.5 text-xs font-bold hover:bg-zinc-200 transition-colors"
            data-testid="cookie-accept-essential">
            Accept Essential
          </button>
          <button onClick={() => accept('all')}
            className="bg-transparent border border-white text-white px-4 py-1.5 text-xs font-bold hover:bg-white hover:text-[#09090B] transition-colors"
            data-testid="cookie-accept-all">
            Accept All
          </button>
          <button onClick={() => accept('essential')} className="p-1 hover:bg-zinc-800" data-testid="cookie-close" aria-label="Close">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
